<template>
  <div>
    <div style="margin-bottom:1rem;">
      <SfButton class="sf-button--text" @click="refreshList">{{ $t('shipping_refresh') }}</SfButton>
    </div>
    <ShippingAddressForm v-if="isFromShow" @save="handlSaveAddress" @cancle="changeShippingFormStatus" />
    <div v-if="!isFromShow">
      <SfAddressPicker :selected="selectedAddressId" class="shppingList" @change="selectShipping">
        <SfAddress v-for="shipping in shippings" :key="shipping.addressId" :name="shipping.addressId + ''"
          class="shippingItem">
          <div>{{ $t('order_shopping_firstname') }}: {{ shipping.firstName }} {{ shipping.lastName }}</div>
          <div v-if="shipping.apartment">{{ $t('MyAccount_MyShippingDetails_HouseNumber') }}:{{ shipping.apartment }}
          </div>
          <div v-if="shipping.zipCode">{{ $t('MyAccount_MyShippingDetails_Zip') }}:{{ shipping.zipCode }}</div>
          <div v-if="shipping.streetName">{{ $t('MyAccount_MyShippingDetails_Street') }}:{{ shipping.streetName }}</div>
          <div v-if="shipping.city">{{ $t('MyAccount_MyShippingDetails_City') }}:{{ shipping.city }}</div>
          <div v-if="shipping.state">{{ $t('MyAccount_MyShippingDetails_State') }}:{{ shipping.state }}</div>
          <div v-if="shipping.country">{{ $t('Country') }}:{{ $t(shipping.country) }}</div>
          <div v-if="shipping.phoneNumber">{{ $t('MyAccount_MyShippingDetails_Phone') }}:{{ shipping.phoneNumber }}
          </div>
        </SfAddress>
      </SfAddressPicker>
      <paginate v-if="totalPageNo>1" v-model="pageNo" :page-count="totalPageNo" :margin-pages="2" :page-range="5"
        :container-class="'sf-pagination products__pagination'" :activeClass="'current'"
        :page-link-class="'sf-pagination__item'" :prev-link-class="'sf-pagination__item'"
        :next-link-class="'sf-pagination__item'" :break-view-link-class="'break-view-link'" :no-li-surround="true"
        @input="changePageNo" hidePrevNext></paginate>
      <div class="add_shipping_link">
        <a href="javascript:" class="sf-link" @click="addNewShipping">
          {{ $t('add_shipping') }}
        </a>
        <SfLink :link="localePath('/my-account/Shipping')
          " class="maringleft">
          {{ $t('shopping_go') }}
        </SfLink>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SfInput,
  SfButton,
  SfSelect,
  SfLink,
  SfAddressPicker
} from '@storefront-ui/vue';
import { ref, useRouter, computed, onMounted } from '@nuxtjs/composition-api';
import { useShipping } from '@bee-hole/coms';
import ShippingAddressForm from '~/components/MyAccount/ShippingAddressForm';
import { usePreviewOrderStore } from '~/stores/previewOrder';
import Paginate from '~/components/Paginate.vue';
export default {
  name: 'ShippingAddressSelect',
  components: {
    SfInput,
    SfButton,
    SfSelect,
    SfLink,
    ShippingAddressForm,
    SfAddressPicker,
    Paginate
  },
  props: {
    addressId: {
      type: String,
      default: ''
    },
    source: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    // const route = useRoute();
    const router = useRouter();
    const isFromShow = ref(false);
    const { load: loadShippingAddress, loading, shipping: shippingResult } = useShipping();
    const shippings = computed(() => shippingResult?.value?.list || []);
    const pageSize = ref(10);
    const totalPageNo = computed(() => Math.ceil(shippingResult?.value?.total / pageSize.value) || 1);
    const selectedAddressId = ref(String(props.addressId));
    const previewOrderStore = usePreviewOrderStore();
    const pageNo = ref(props.source === 'Billing' ? previewOrderStore?.billingPageNo : previewOrderStore.shippingPageNo || 1);
    // 选中收货地址
    const selectShipping = (addressId) => {
      const shipping = shippings.value?.find((shipping) => String(shipping?.addressId) === String(addressId));
      if (addressId) {
        emit('getAddress', shipping, pageNo.value);
        selectedAddressId.value = String(addressId);
      }
    };

    const addNewShipping = () => {
      isFromShow.value = true;
      emit('getAddress', null);
      // selectShipping('');
    };

    const changeShippingFormStatus = () => {
      isFromShow.value = !isFromShow.value;
      emit('changeShippingFormStatus', isFromShow.value);
    };

    // 保存收货地址
    const handlSaveAddress = async (res) => {
      if (res?.addressId) {
        selectShipping(res?.addressId);
      }
      changeShippingFormStatus();
    };
    const refreshList = () => {
      // if (route.value?.query?.page) {
      //   pageNo.value = Number(route.value.query.page);
      // }
      const query = {
        limit: pageSize.value,
        page: pageNo.value
      };
      // 加载收货地址
      return loadShippingAddress({ customQuery: query}).then((res) => {
        // 是否默认显示表单
        if (!shippings.value || !shippings.value?.length) {
          isFromShow.value = true;
        } else {
          isFromShow.value = false;
        }
        return res;
      });
    };
    const changePageNo = (page_no) => {
      pageNo.value = page_no;
      refreshList();
    };
    // 默认选中第一个收货地址
    const initSelectShipping = () => {
      const addId = props.addressId || '';
      if (addId) {
        if (addId !== '' && addId !== null && addId !== undefined) {
          // selectShipping(addId);
          const builing = previewOrderStore.builing;
          const shipping = previewOrderStore.address;
          if (props.source === 'Billing' && builing) {
            emit('getAddress', builing, pageNo.value);
            selectedAddressId.value = String(previewOrderStore.builing?.addressId);
          } else if (props.source === 'Shipping' && shipping) {
            emit('getAddress', shipping, pageNo.value);
            selectedAddressId.value = String(previewOrderStore.address?.addressId);
          } else if (shippings.value && shippings.value?.length) {
            selectShipping(shippings?.value[0]?.addressId);
          }
        }
      } else if (shippings.value && shippings.value?.length) {
        if (props.source !== 'Billing') {
          selectShipping(shippings?.value[0]?.addressId);
        }
      } else {
        selectShipping('');
      }
      // else if (previewOrderStore?.address?.addressId && previewOrderStore?.address?.addressId !== '') {
      //   selectShipping(previewOrderStore?.address?.addressId);
      // }
    };
    const init = async () => {
      // if (previewOrderStore?.address?.addressId && previewOrderStore?.address?.addressId !== '') {
      //   initSelectShipping();
      // }
      await refreshList();
      // 默认选中收货地址
      initSelectShipping();
    };
    onMounted(() => {
      init();
    });
    return {
      router,
      loading,
      selectShipping,
      shippings,
      isFromShow,
      selectedAddressId,
      handlSaveAddress,
      changeShippingFormStatus,
      addNewShipping,
      refreshList,
      pageNo,
      totalPageNo,
      pageSize,
      changePageNo
    };
  }
};
</script>

<style lang="scss" scoped>
.form {
  --button-width: 100%;

  &__select {
    display: flex;
    align-items: center;
    --select-option-font-size: var(--font-size--lg);

    ::v-deep .sf-select__dropdown {
      font-size: var(--font-size--lg);
      margin: 0;
      color: var(--c-text);
      font-family: var(--font-family--secondary);
      font-weight: var(--font-weight--normal);
    }
  }

  @include for-desktop {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    --button-width: auto;
  }

  &__element {
    margin: 0 0 var(--spacer-xl) 0;

    @include for-desktop {
      flex: 0 0 100%;
    }

    &--half {
      @include for-desktop {
        flex: 1 1 50%;
      }

      &-even {
        @include for-desktop {
          padding: 0 0 0 var(--spacer-xl);
        }
      }
    }
  }

  &__action {
    @include for-desktop {
      flex: 0 0 100%;
      display: flex;
    }
  }

  &__action-button {
    &--secondary {
      @include for-desktop {
        order: -1;
        text-align: left;
      }
    }

    &--add-address {
      width: 100%;
      margin: 0;

      @include for-desktop {
        margin: 0 0 var(--spacer-lg) 0;
        width: auto;
      }
    }
  }

  &__action-button2 {
    margin-left: 20px;
    // &--secondary {
    //   @include for-desktop {
    //     order: -1;
    //     text-align: left;
    //   }
    // }
    // &--add-address {
    //   width: 100%;
    //   margin: 0;
    //   @include for-desktop {
    //     margin: 0 0 var(--spacer-lg) 0;
    //     width: auto;
    //   }
    // }
  }

  &__back-button {
    margin: var(--spacer-xl) 0 var(--spacer-sm);

    &:hover {
      color: var(--c-white);
    }

    @include for-desktop {
      margin: 0 var(--spacer-xl) 0 0;
    }
  }
}

.add_shipping_link {
  margin-bottom: 20px;
}

.maringleft {
  margin-left: 20px;
}

.shipping {
  &__label {
    display: flex;
    justify-content: space-between;
  }

  &__description {
    --radio-description-margin: 0;
    --radio-description-font-size: var(--font-xs);
  }
}

.title {
  margin: var(--spacer-xl) 0 var(--spacer-base) 0;
}

.shppingList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.shippingItem {
  margin-bottom: 20px;
}
</style>
